import { jsx as _jsx } from "react/jsx-runtime";
import { Radio } from "./Radio";
import { FlexWithMargin } from "./styled";
import { RadioContext } from "./context";
export const RadioGroup = ({ column, value, disabled, options, onChange, children }) => (_jsx(RadioContext.Provider, { value: { radioGroup: { value, disabled, onChange } }, children: _jsx(FlexWithMargin, { column: column, children: options
            ? options.map((item) => (_jsx(Radio, { value: item.value, label: item.label, onChange: onChange, disabled: item.disabled }, item.value)))
            : children }) }));
